/**
 *
 * ContentWrapper
 *
 */

import "./styles.scss";

import React from "react";

export class ContentWrapper extends React.Component<any, any> {
	render() {
		const { extraClass, children } = this.props;

		return (
			<div className={`ContentWrapper${extraClass ? ` ${extraClass}` : ""}`}>
				{children}
			</div>
		);
	}
}

export default ContentWrapper;
